import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'underscore';

import { getRGB } from "../../lib/color";
import {partitionBySize} from '../helper/partition';
import PDFViewer from '../components/pdfViewer';
import { css_file_to_url } from "../helper/css-util";
import Logo from '../components/Logo/Logo';

const footerEntities = [
  "contact",
  "mobile",
  "press_room",
  "careers",
  "faq",
  "support",
  "security",
  "site-map",
  "ira",
  "investment_accounts",
  "college_investment_accounts",
  "terms",
  "privacy_policy",
  "form_adv_part_1",
  "form_adv_part_2"
];

const getLinkType = (urlString, config, wlf_id) => {
  // Regex for absolute URL
  var urlRE = /^https?:\/\//i;

  // Email Regex
  var emailRE = /^(([^<>()[]\\.,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const fileExt = urlString.split('.').pop();
  if (urlString.startsWith(wlf_id)) {
    urlString = css_file_to_url(config, urlString);
  }

  if(fileExt === 'pdf'){
    return {
      url: urlString,
      target: 'pdf'
    }
  }
  if(emailRE.test(String(urlString).toLowerCase())){
    // URL is an email ID
    return {
      url:'mailto:' + urlString,
      target: '_top'
    };
  }
  if (urlRE.test(urlString)){
    return {
      url:urlString,
      target: '_balnk'
    };
  } else {
    return {
      url:urlString,
      target: '_top'
    };
  }
}
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = { pdfDocument: false };
  }

  viewPDF = (pdfFile) => {
    this.setState({pdfDocument:pdfFile})
  }

  closePdfViewer = () => {
    this.setState({pdfDocument:null})
  }

  renderPdfViewer = () => {
    return(
      <PDFViewer url={"/assets/pdf/?u=" + this.state.pdfDocument + "&v=y"}
                 onClose={this.closePdfViewer}/>
    )
  };

  render() {

    if (this.props.location.pathname === '/') {
      // Show nothing if we're in the WLF selector
      return null;
    }
    const is_tiny = this.props.app.device === "tiny"

    const {
      color,
      address,
      phone,
      footer,
      clientName,
      copyright_info,
      disclosure_info,
      support_email
    } = this.props.client;

    const footer_color = getRGB(color.footer_background);
    const footerPrimaryTextColor = getRGB(color.footer_primary_text);
    const footerSecondaryTextColor = getRGB(color.footer_secondary_text);
    
    // Make footer partion of 4 to fit columns

    let footerLinks = _.sortBy(footer, (link, key) => {
      return _.indexOf(footerEntities, key);
    });

    footerLinks = _.filter(footerLinks, item => {
      return item.show && item.label && item.label !== '' && item.url && item.url !== '';
    }) 
    footerLinks = partitionBySize(footerLinks, 4);

    const containerStyle = {
      background:footer_color,
      color:footerPrimaryTextColor,
      paddingLeft: is_tiny ? "1rem" : "7.5rem",
      paddingRight: is_tiny ? "1rem" : "7.5rem",
    };

    const logoSrc = css_file_to_url(this.props.config, this.props.client.footer_logo)

    return (
      <div className="footer-main-block" style={containerStyle}>
        {/* Footer Logo */}
        <Logo src={logoSrc} alt={'footer_logo'} logo={this.props.client.footer_logo}/>

        <div className="cleveralpha-address-block" style={{color:footerSecondaryTextColor}}>
          <p className="footer-cleveralpha-text" style={{color:footerPrimaryTextColor}}>{clientName}</p>
          <p>{address[0]} &#124; {address[1]} &#124; {phone} </p>
          {support_email && <a href="mailto:support@cleveralpha.com"
             style={{color:footerSecondaryTextColor}}
             target="_top">{support_email}</a>}
        </div>
          <div className="columns footer-links">
            {/* Generate Footer Links */}
            {
              _.map(footerLinks, (col, index) => {
                return(
                  <div key={index} className="column">
                    {_.map(col, (link, index) => {
                      let linkType = getLinkType(link.url, this.props.config, this.props.wlf_id);
                      //if(linkType.target === 'pdf' ){
                      if(false){
                        return (
                          <p key={index}>
                            <a onClick={e => this.viewPDF(linkType.url)}
                               style={{color:footerPrimaryTextColor}}>{link.label}</a>
                          </p>);
                      } else {
                        return (
                          <p key={index}>
                            <a href={linkType.url} target={linkType.target}
                               style={{color:footerPrimaryTextColor}}>{link.label}</a>
                          </p>);
                      }
                    })}
                  </div>
                )
              })
            }
          </div>
          {copyright_info && copyright_info !== "" &&
          <div className="columns footer-copyright" style={{color:footerSecondaryTextColor}}>
              <p className="column">{copyright_info}</p>
          </div>}
          {disclosure_info && disclosure_info !== "" &&
          <div className="columns footer-about-cleveralpha" style={{color:footerSecondaryTextColor}}>
              <p className="column">{disclosure_info}</p>
          </div>}
          {this.state.pdfDocument ? this.renderPdfViewer():null}
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.client,
    config: state.app.config,
    wlf_id: state.app.wlf && state.app.wlf.id,
    app: state.app,
  };
}

export default connect(mapStateToProps)(Footer);
